import React, { useState } from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { backGround } from "../layout/customStyle";
import lecturesData from "../assets/lectures.json";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import SectionHeading from "../components/SectionHeading";
import { Grid, Card, CardMedia, CardContent, Typography } from "@material-ui/core";

const LectureSeriesPage = () => {
    const years = Object.keys(lecturesData).sort((a, b) => b - a);
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentYear = years[currentIndex];
    const lectures = lecturesData[currentYear].lectures;

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? years.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === years.length - 1 ? 0 : prev + 1));
    };

    const styles = {
        container: {
            textAlign: "center",
            color: "#fff",
            padding: "3rem 1rem",
        },
        header: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            marginBottom: "2rem",
            flexWrap: "wrap",
        },
        year: {
            fontSize: "2rem",
            fontWeight: "600",
            color: "white",
            textShadow: "0 0 8px rgba(255,215,0,0.3)",
        },
        arrow: {
            background: "transparent",
            border: "none",
            color: "#FFD700",
            cursor: "pointer",
            transition: "transform 0.2s ease",
        },
        card: {
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            background: "rgba(255, 255, 255, 0.08)",
            borderRadius: "1rem",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            overflow: "hidden",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            maxWidth: "1000px",
            margin: "0 auto",
        },
        cardHover: {
            transform: "translateY(-6px)",
            boxShadow: "0 6px 18px rgba(0, 0, 0, 0.5)",
        },
        img: {
            width: "40%",
            objectFit: "cover",
        },
        info: {
            flex: 1,
            color: "#fff",
            padding: "1rem 1.5rem",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        },
        title: {
            fontSize: "1.4rem",
            fontWeight: "600",
            marginBottom: "0.5rem",
        },
        text: {
            color: "#ddd",
            marginTop: "0.3rem",
        },
        comingSoon: {
            color: "#FFD700",
            fontSize: "2rem",
            marginTop: "2rem",
        },
    };

    return (
        <main style={backGround}>
            <Navbar lecture={true} />

            <div style={styles.container}>
                <div style={styles.header}>
                    {years.length > 1 && (
                        <button
                            style={styles.arrow}
                            onClick={handlePrev}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
                        >
                            <ArrowBack fontSize="large" />
                        </button>
                    )}

                   <SectionHeading title={`LECTURE SERIES ${currentYear}`} />
    
                    {years.length > 1 && (
                        <button
                            style={styles.arrow}
                            onClick={handleNext}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
                        >
                            <ArrowForward fontSize="large" />
                        </button>
                    )}
                </div>

                {lectures.length > 0 ? (
                    <Grid container spacing={3} justifyContent="center">
                        {lectures.map((lecture, idx) => (
                            <Grid item xs={12} key={`lecture-${idx}`}>
                                <Card
                                    style={styles.card}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = styles.cardHover.transform;
                                        e.currentTarget.style.boxShadow = styles.cardHover.boxShadow;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = styles.card.boxShadow;
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={lecture.imagePath}
                                        alt={lecture.title}
                                        style={styles.img}
                                        loading="lazy"
                                    />
                                    <CardContent style={styles.info}>
                                        <Typography variant="h6" style={styles.title}>
                                            {lecture.title}
                                        </Typography>
                                        <Typography variant="body2" style={styles.text}>
                                            <strong>Speaker:</strong> {lecture.speaker}
                                        </Typography>
                                        <Typography variant="body2" style={styles.text}>
                                            <strong>Date:</strong> {lecture.date}
                                        </Typography>
                                        <Typography variant="body2" style={styles.text}>
                                            <strong>Venue:</strong> {lecture.venue}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <div
                        style={{
                            minHeight: "43vh", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Typography style={styles.comingSoon}>Coming Soon...</Typography>
                    </div>
                )}

            </div>

            <Footer />
        </main>
    );
};

export default LectureSeriesPage;
